// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3684698a] .metadata-grid{display:inline}[data-v-3684698a] .metadata-grid .ag-row-hover,[data-v-3684698a] .metadata-grid .ag-row-selected{background:rgba(33,150,243,.1);cursor:pointer}.select-wrapper[data-v-3684698a]{display:flex;align-items:baseline;gap:5px}.select-wrapper span[data-v-3684698a]{width:250px}", ""]);
// Exports
module.exports = exports;
